export default __webpack_public_path__ + "static/media/resource-on-hold.87ce5ae2.svg";